var _classCallCheck = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/me/Repos/michaelavila/knex-querylab/node_modules/@babel/runtime/helpers/inherits");

var Formatter = require('../../formatter');

var Raw = require('../../raw');

module.exports =
/*#__PURE__*/
function (_Formatter) {
  "use strict";

  _inherits(SQlite3_Formatter, _Formatter);

  function SQlite3_Formatter() {
    _classCallCheck(this, SQlite3_Formatter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SQlite3_Formatter).apply(this, arguments));
  }

  _createClass(SQlite3_Formatter, [{
    key: "values",
    value: function values(_values) {
      var _this = this;

      if (Array.isArray(_values)) {
        if (Array.isArray(_values[0])) {
          return "( values ".concat(_values.map(function (value) {
            return "(".concat(_this.parameterize(value), ")");
          }).join(', '), ")");
        }

        return "(".concat(this.parameterize(_values), ")");
      }

      if (_values instanceof Raw) {
        return "(".concat(this.parameter(_values), ")");
      }

      return this.parameter(_values);
    }
  }]);

  return SQlite3_Formatter;
}(Formatter);